import type {
  AfriexTransactionFeeLimitType,
  AfriexTransactionFeeType,
} from '@afriex/core/domain/enums';

import {capitalizeWords} from '@/utils/strings';

import {AfriexCurrencyCode} from './AfriexCurrencyCode';
import {FeeTransactionChannels, FeeTransactionTypes} from './Transaction';

export type AfriexFeeType = {
  baseFee?: TransactionFee;
  overrideFees: TransactionFee[];
};

export type TransactionFee = {
  id?: string; // is draft when undefined
  paymentMethod?: FeeTransactionChannels;
  baseValue?: number;
  percentValue?: number;
  maxFeeValue?: number;
  limitType?: AfriexTransactionFeeLimitType;
  limit?: number;
  currencyPair?: string;
  type: AfriexTransactionFeeType;
  transactionType?: FeeTransactionTypes;
};

export const currencyPairOptions = [
  {key: 'Any', value: '*'},
  ...Object.values(AfriexCurrencyCode).map((currency) => ({
    key: currency,
    value: currency,
  })),
];

export const paymentMethodOptions = [
  {key: 'Any', value: 'any'},
  ...Object.values(FeeTransactionChannels).map((method) => ({
    key: capitalizeWords(method.replace(/_/g, ' ')),
    value: method,
  })),
];

export const getFeeTransactionTypesOptions = [
  {key: 'Any', value: 'any'},
  ...Object.values(FeeTransactionTypes).map((key) => ({
    key: capitalizeWords(key.replace(/_/g, ' ')),
    value: key,
  })),
];

export const limitTypeOptions = [
  {key: 'None', value: 'none'},
  {key: 'Above', value: 'above'},
  {key: 'Below', value: 'below'},
];
